import styled from 'styled-components'

import { Box, Flex } from 'app/components/design-system-components'
import { mediaQueries } from 'app/components/design-system-components/styles/variables'
import MuvalLogoAndDesc from 'app/Integrations/components/Muval/ImageAndText'
import MuvalPreApprovedButton from 'app/Integrations/components/Muval/PreApprovedButton'
import theme from 'app/match/applicationReportPDF/assets/theme'

const StyledFlex = styled(Flex)`
  line-height: 140%;
  color: ${theme.colors.gray800};
  .text {
    width: 70%;
    margin-right: ${theme.space[3]}px;
  }
  .image {
    width: ${theme.width[31]}px;
  }
  ${mediaQueries.sm} {
    flex-direction: column;
    width: 100%;
    text-align: center;
    .text {
      width: 100%;
    }
    .image {
      width: 100%;
      margin-top: ${theme.space[5]}px;
    }
  }
`

const StyledMuvalPreApprovedButton = styled(MuvalPreApprovedButton)`
  ${mediaQueries.sm} {
    margin-top: ${theme.space[4]}px;
  }
`

export interface MuvalBannerProps {
  trackingClassName: string
  linkParam?: string | undefined
}

function MuvalBanner({ trackingClassName }: MuvalBannerProps) {
  return (
    <StyledFlex
      alignItems="center"
      p={5}
      justifyContent="space-between"
      width="100%"
    >
      <Box className="text">
        <MuvalLogoAndDesc />
      </Box>
      <Box className="image">
        <StyledMuvalPreApprovedButton trackingClassName={trackingClassName} />
      </Box>
    </StyledFlex>
  )
}

export default MuvalBanner
